module.exports = __webpack_public_path__ + "static/icon-sat1-9d45ca1a6d0a708e448b0052e0d6d48d.svg";